import { AutoTextarea, Field, ListEditor } from "./shared";

export const ExperientialForm = ({ data, onChange, specs }) => {
  const set = (k) => (v) => onChange({ ...data, [k]: v });
  const techniques = specs.experiential_techniques;
  return (
    <div className="space-y-3" data-testid="experiential-form">
      <div className="grid md:grid-cols-3 gap-3">
        <Field label="Technique">
          <select className="w-full text-sm rounded-lg border border-border bg-background px-2 py-1.5" value={data.technique || ""} onChange={(e) => set("technique")(e.target.value)} data-testid="exp-technique">
            <option value="">—</option>
            {techniques.map((t) => <option key={t} value={t}>{t}</option>)}
            {data.technique && !techniques.includes(data.technique) && <option value={data.technique}>{data.technique}</option>}
          </select>
        </Field>
        <Field label="Mode(s) ciblé(s)"><input className="w-full text-sm rounded-lg border border-border bg-background px-2 py-1.5" value={data.target_mode || ""} onChange={(e) => set("target_mode")(e.target.value)} list="modes-list" data-testid="exp-target-mode" /></Field>
        <Field label="Objectif"><AutoTextarea value={data.objective} onChange={set("objective")} rows={1} testId="exp-objective" /></Field>
      </div>
      <div className="grid md:grid-cols-[1.2fr_1fr] gap-3">
        <Field label="Déroulé pas à pas" hint="Une étape par ligne">
          <ListEditor value={data.script} onChange={set("script")} rows={10} testId="exp-script" />
        </Field>
        <div className="space-y-3">
          <Field label="Ce qui s'est passé en séance"><AutoTextarea value={data.what_happened} onChange={set("what_happened")} rows={3} testId="exp-what-happened" /></Field>
          <Field label="Réactions du patient"><AutoTextarea value={data.patient_reactions} onChange={set("patient_reactions")} rows={3} testId="exp-reactions" /></Field>
          <Field label="Messages de reparentage (Adulte sain → Enfant vulnérable)"><AutoTextarea value={data.healthy_adult_messages} onChange={set("healthy_adult_messages")} rows={3} className="border-emerald-300 bg-emerald-50/50 dark:bg-emerald-950/20" testId="exp-messages" /></Field>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <Field label="Suites / travail personnel" hint="Un par ligne"><ListEditor value={data.follow_up} onChange={set("follow_up")} rows={3} testId="exp-follow-up" /></Field>
        <Field label="Précautions" hint="Une par ligne"><ListEditor value={data.cautions} onChange={set("cautions")} rows={3} testId="exp-cautions" /></Field>
      </div>
      <datalist id="modes-list">{specs.modes.map((m) => <option key={m} value={m} />)}</datalist>
    </div>
  );
};
